import script from "./Sticker.vue?vue&type=script&setup=true&lang=ts"
export * from "./Sticker.vue?vue&type=script&setup=true&lang=ts"

import "./Sticker.vue?vue&type=style&index=0&id=75d391f4&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-75d391f4"]])

export default __exports__